import React from 'react'
import api, { METHODS } from './api'
import Report, { newReport } from '../common/types/api/report'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'

export default async function updateReport(report: Report): Promise<newReport> {
    try {
        const res = await api<newReport>(`update`, METHODS.POST, JSON.stringify(report))
        if (!res.success) {
            GlobalNotification.error(
                <Notification title={i18n('Error trying to update report: ')}>{'unknown error'}</Notification>,
                20
            )

            console.error(res)
        } else {
            GlobalNotification.success(
            <Notification title={i18n('Report updated successfully!')} />,
             20)
        }

        return res
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to update report:')}>{error}</Notification>,
            20
        )

        console.error(error)

        return null
    }
}
